import imgKanade81 from "./img-kanade8 (1).webp";
import imgKanade82 from "./img-kanade8 (2).webp";
import imgKanade83 from "./img-kanade8 (3).webp";

const imgKanade8 = [imgKanade81, imgKanade82, imgKanade83];

export default imgKanade8;
